var map = {
	"./Customers/VPS-foods.jpg": 753,
	"./Customers/VPS-khandevane.jpg": 754,
	"./Customers/VPS-manufacturing-firms.jpg": 755,
	"./Customers/VPS-sunich.jpg": 756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;